import * as Yup from "yup";

import { getInjuriesSchema } from "Components/Form/RecentDamages/validation";
import { TextManager } from "Components/TextContext";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { TravelProductIntroFormValues } from "./travelProductIntroInterfaces";

export const validationSchema =
  (): Yup.ObjectSchema<TravelProductIntroFormValues> => {
    const { getText } = TextManager;
    return Yup.object({
      isInsuranceFor: Yup.mixed<BooleanFormType>().required(
        getText("travelform.validation.isinsurancefor"),
      ),
    })
      .concat(getInjuriesSchema())
      .defined();
  };
